import IdentityObject from "@/src/domain/common/identity-object";

export enum RouteType {
  PUBLIC = "public",
  PRIVATE = "private",
}

export default abstract class RouteService extends IdentityObject {
  abstract get currentRouteType(): RouteType;
  abstract setRouteType(routeType: RouteType): void;
  abstract get isPrivateRoute(): boolean;
  abstract get isPublicRoute(): boolean;
}
